import {
  registerDecorator,
  ValidatorConstraint,
  type ValidationOptions,
  type ValidationArguments,
  type ValidatorConstraintInterface,
} from 'class-validator';
import { validateRgbaOrGradient } from './validateColor';

/**
 * Validates that a value is either:
 * 1. An RGBA object: { r: 0-255, g: 0-255, b: 0-255, a: 0-1 }
 * 2. A Gradient object: { type: 'Linear' | 'Radial', stops: [...], ... }
 * 3. A color reference string: '$ref:#/colors/color[1-6]'
 */
export
@ValidatorConstraint({ name: 'isColorOrReference', async: false })
class IsColorOrReferenceConstraint implements ValidatorConstraintInterface {
  validate(value: unknown) {
    // Allow null for optional fields
    if (value === null) {
      return true;
    }

    if (typeof value === 'string') {
      const colorRefPattern = /^\$ref:#\/colors\/color[1-6]$/;
      return colorRefPattern.test(value);
    }

    return validateRgbaOrGradient(value);
  }

  defaultMessage(args: ValidationArguments) {
    return `${args.property} must be either a valid RGBA object {r: 0-255, g: 0-255, b: 0-255, a: 0-1}, a Gradient object, or a reference string like '$ref:#/colors/color1'`;
  }
}

export function IsColorOrReference(validationOptions?: ValidationOptions) {
  return function (object: object, propertyName: string) {
    registerDecorator({
      target: object.constructor,
      propertyName: propertyName,
      options: validationOptions,
      constraints: [],
      validator: IsColorOrReferenceConstraint,
    });
  };
}
